import { Box, Button, Card, Divider, Grid, Tab, Tabs, Typography } from '@mui/material';
import FormProvider from 'src/components/hook-form';
import AddEditActivity from '../activity-page/activity-page';
import { useRouter } from 'src/routes/hooks';
import Iconify from 'src/components/iconify';
import { useCallback, useState } from 'react';
import AssignPage from '../assign-page/assign-page';

export default function ActivityAssignPage() {
  const [currentTab, setCurrentTab] = useState('Task Activity');

  const router = useRouter();
  const handleChangeTab = useCallback((event, newValue) => {
    setCurrentTab(newValue);
  }, []);
  return (
    <>
      <Card
        sx={{
          width: '100%',
          margin: 'auto',
          mt: 4,
          p: 3,
          boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
        }}
      >
        <Box>
          <Tabs value={currentTab} onChange={handleChangeTab}>
            {[
              { label: 'Task Activity', value: 'Task Activity' },
              { label: 'Assign Resources', value: 'Assign Resources' },
            ].map((tab) => (
              <Tab key={tab.value} value={tab.value} label={tab.label} />
            ))}
          </Tabs>
        </Box>
        <Divider sx={{ mb: 4 }} />
        {currentTab == 'Task Activity' ? (
          <>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography variant="h6" className="heading1">
                  Cost Code Category & Cost Codes
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                  <Button
                    startIcon={<Iconify icon="ic:round-keyboard-backspace" />}
                    onClick={router.back}
                    variant="text"
                    className="riskbutton"
                  >
                    Go Back
                  </Button>
                </Box>
              </Grid>
            </Grid>
            <AddEditActivity />
          </>
        ) : (
          <>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography variant="h6" className="heading1">
                 Assign Resources To Activity
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                  <Button
                    startIcon={<Iconify icon="ic:round-keyboard-backspace" />}
                    onClick={router.back}
                    variant="text"
                    className="riskbutton"
                  >
                    Go Back
                  </Button>
                </Box>
              </Grid>
            </Grid>
            <AssignPage/>
          </>
        )}
      </Card>
    </>
  );
}
